import React, { useState } from 'react';
import { PlayCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Ambassadrice UGC (Facebook Reel)
// NOTE: l'iframe est chargée au clic pour limiter le tracking tiers et améliorer les performances.
const FB_REEL_SRC =
  'https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2328546247666587%2F&show_text=false&width=267&t=0';

export default function UgcFacebookReel({ className = '', title = 'Retour d’expérience TrésoPilot (Facebook)' }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={[
        'relative w-full max-w-[320px] aspect-[9/16] overflow-hidden rounded-2xl border border-slate-200 bg-slate-900/5 shadow-sm',
        className,
      ].join(' ')}
    >
      {isLoaded ? (
        <iframe
          src={FB_REEL_SRC}
          title={title}
          className="absolute inset-0 h-full w-full"
          style={{ border: 'none', overflow: 'hidden' }}
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-5 text-center">
          <div className="flex items-center justify-center rounded-2xl bg-white/80 p-3 shadow-sm ring-1 ring-slate-200">
            <PlayCircle className="h-8 w-8 text-slate-900" />
          </div>
          <div className="space-y-1">
            <div className="text-sm font-semibold text-slate-900">Voir le retour d’expérience d’une ambassadrice</div>
            <div className="text-xs text-slate-600">Cliquez pour charger la vidéo Facebook (service tiers).</div>
          </div>
          <Button size="sm" onClick={() => setIsLoaded(true)}>
            Charger la vidéo
          </Button>
        </div>
      )}
    </div>
  );
}
